import React, { useContext } from 'react'
import { getLanguageLocale, getMarket, CircleSpinner } from 'shared/index'
import {
	initiateUserUpdate,
	ContactInfoChangeType,
} from 'selfServicePortal/services/CustomerServices/updateUserService'
import { FormBuilder } from '@tf/formbuilder'
import { FormWrapper } from 'shared/formBuilder/formWrapper'
import { AccountEmailFormDE_AT } from 'shared/formBuilder/forms/customerInformationFormDE_AT'
import { useTranslation } from 'react-i18next'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'
import { ISubmitCustomerInformation } from '../MyAccount'
import { useMutation } from '@tanstack/react-query'
import { getErrorMessage } from 'selfServicePortal/utils'
import { Heading } from 'selfServicePortal/components'
import { OtpDistributionChannel } from 'selfServicePortal/interfaces/i-api-sdd'

function deriveEmailForm(formMeta: any, data: any) {
	return FormWrapper([AccountEmailFormDE_AT(data)], formMeta)
}

interface EmailFormProps {
	onSuccess: (sessionId: string) => void
}

export function EmailForm({ onSuccess }: EmailFormProps) {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const initiateUserUpdateMutation = useMutation(
		(formData: ICustomer) =>
			initiateUserUpdate({
				customerId: customerData?.customerId,
				firstName: customerData?.firstName,
				lastName: customerData?.lastName,
				market: getMarket(),
				emailAddress: customerData?.email,
				newContactDetail: formData.email,
				changeType: ContactInfoChangeType.Email,
				distributionChannel: OtpDistributionChannel.Email,
			}),
		{
			onSuccess: ({ sessionId }) => onSuccess(sessionId),
		},
	)

	const emailFormSchema = deriveEmailForm(
		{
			formName: 'email',
			blockName: 'email',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
			submitButtonText: t('Save'),
		},
		customerData,
	)

	if (initiateUserUpdateMutation.isLoading) {
		return <CircleSpinner />
	}

	return (
		<>
			<Heading
				title={t('<Title Here>')}
				description={t('<Desctiption Here>')}
			/>

			<FormBuilder
				formSchema={emailFormSchema}
				apiError={undefined}
				showErrorsInForm={true}
				showSubmitButton={true}
				onSubmit={(values: ISubmitCustomerInformation) =>
					initiateUserUpdateMutation.mutate(values.customer)
				}
			/>

			{initiateUserUpdateMutation.isError && (
				<div className="error-msg">
					{getErrorMessage(initiateUserUpdateMutation.error)}
				</div>
			)}
		</>
	)
}
